var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.h5video[data-v-7329a470]{\n    /* height: 327px; */\n}\n.riskdetail[data-v-7329a470]{\n    background: -webkit-linear-gradient(left, #cecece, #fbfbfb);\n}\n.riskdetailicon[data-v-7329a470]{\n    display: inline-block;\n    position: absolute;\n    width: 1rem;\n    height: 1rem;\n    margin: .2rem .5rem .5rem .5rem;\n    background: url(" + escape(require("../assets/images/jiedu.png")) + ") no-repeat center center / 100% 100%;\n}\n.vjs-tech[data-v-7329a470] {\n    pointer-events: none;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7329a470","scoped":true,"hasInlineConfig":false}!./node_modules/vux-loader/src/style-loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Risk_ItemVideo.vue
// module id = mbMD
// module chunks = 1